import {CssDimensionRestDto, OverlayPositionRestDto} from "@/api/pharma-cms-content-page/models";
import {OverlayPositionTypeEnum} from "@/api/enums/overlay-position-type-enum";
import {CssDimensionRestDtoModel} from "@/models/api/pharma-cms-content-page/CssDimensionRestDtoModel";

export class OverlayPositionRestDtoModel implements OverlayPositionRestDto {
    position_type_code?: OverlayPositionTypeEnum | null;
    top?: CssDimensionRestDto | null;
    right?: CssDimensionRestDto | null;
    bottom?: CssDimensionRestDto | null;
    left?: CssDimensionRestDto | null;

    static createWithDefaults(): OverlayPositionRestDtoModel {
        const model: OverlayPositionRestDtoModel = new this();
        model.position_type_code = OverlayPositionTypeEnum.ABSOLUTE;
        return model;
    }

    static cloneFrom(source: OverlayPositionRestDto): OverlayPositionRestDtoModel {
        const clone: OverlayPositionRestDtoModel = new this();
        clone.position_type_code = source.position_type_code ?? null;
        clone.top = source.top ? CssDimensionRestDtoModel.cloneFrom(source.top) : null;
        clone.right = source.right ? CssDimensionRestDtoModel.cloneFrom(source.right) : null;
        clone.bottom = source.bottom ? CssDimensionRestDtoModel.cloneFrom(source.bottom) : null;
        clone.left = source.left ? CssDimensionRestDtoModel.cloneFrom(source.left) : null;
        return clone;
    }
}
